module.exports = __webpack_public_path__ + "img/icn_App@3x.c635b795.png";